import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Restaurants from "./scenes/restaurants";
import Ingredients from "./scenes/ingredients";
import MenuItems from "./scenes/menuitems";
import Menus from "./scenes/menus";
import Recipes from "./scenes/recipes";
import Vendors from "./scenes/vendors";
import Customers from "./scenes/customers";
import Employees from "./scenes/employees";
import Inventory from "./scenes/inventory";
import OrderManagement from "./scenes/ordermanagement";
import OrderManagementByPaymentMethod from "./scenes/ordermanagement/indexByPaymentMethod";
import SalesRecording from "./scenes/salesrecording";
import SalesRecordingByPaymentMethod from "./scenes/salesrecording/indexByPaymentMethod";
import SalesRecordingByStatus from "./scenes/salesrecording/indexByStatus";
import ExpenseTracking from "./scenes/expensetracking";
import ExpenseTrackingByPaymentMethod from "./scenes/expensetracking/indexByPaymentMethod";
import ExpenseTrackingByStatus from "./scenes/expensetracking/indexByStatus";
import ExpenseTrackingByCurrency from "./scenes/expensetracking/indexByCurrency";
import Payroll from "./scenes/payroll";
import PayrollByPaymentStatus from "./scenes/payroll/indexByPaymentStatus";
import Attendance from "./scenes/attendance";
import EmployeeSchedules from "./scenes/employeeschedules";
import TimeTracking from "./scenes/timetracking";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/restaurants" element={<ProtectedRoute element={<Restaurants searchTerm={searchTerm} />} />} />
<Route path="/ingredients" element={<ProtectedRoute element={<Ingredients searchTerm={searchTerm} />} />} />
<Route path="/menuitems" element={<ProtectedRoute element={<MenuItems searchTerm={searchTerm} />} />} />
<Route path="/menus" element={<ProtectedRoute element={<Menus searchTerm={searchTerm} />} />} />
<Route path="/recipes" element={<ProtectedRoute element={<Recipes searchTerm={searchTerm} />} />} />
<Route path="/vendors" element={<ProtectedRoute element={<Vendors searchTerm={searchTerm} />} />} />
<Route path="/customers" element={<ProtectedRoute element={<Customers searchTerm={searchTerm} />} />} />
<Route path="/employees" element={<ProtectedRoute element={<Employees searchTerm={searchTerm} />} />} />
<Route path="/inventory" element={<ProtectedRoute element={<Inventory searchTerm={searchTerm} />} />} />
<Route path="/inventory/list" element={<ProtectedRoute element={<Inventory searchTerm={searchTerm} />} />} />
<Route path="/ordermanagement" element={<ProtectedRoute element={<OrderManagement searchTerm={searchTerm} />} />} />
<Route path="/ordermanagement/list" element={<ProtectedRoute element={<OrderManagement searchTerm={searchTerm} />} />} />
<Route path="/ordermanagement/paymentmethod" element={<ProtectedRoute element={<OrderManagementByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/salesrecording" element={<ProtectedRoute element={<SalesRecording searchTerm={searchTerm} />} />} />
<Route path="/salesrecording/list" element={<ProtectedRoute element={<SalesRecording searchTerm={searchTerm} />} />} />
<Route path="/salesrecording/paymentmethod" element={<ProtectedRoute element={<SalesRecordingByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/salesrecording/status" element={<ProtectedRoute element={<SalesRecordingByStatus searchTerm={searchTerm} />} />} />
<Route path="/expensetracking" element={<ProtectedRoute element={<ExpenseTracking searchTerm={searchTerm} />} />} />
<Route path="/expensetracking/list" element={<ProtectedRoute element={<ExpenseTracking searchTerm={searchTerm} />} />} />
<Route path="/expensetracking/paymentmethod" element={<ProtectedRoute element={<ExpenseTrackingByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/expensetracking/status" element={<ProtectedRoute element={<ExpenseTrackingByStatus searchTerm={searchTerm} />} />} />
<Route path="/expensetracking/currency" element={<ProtectedRoute element={<ExpenseTrackingByCurrency searchTerm={searchTerm} />} />} />
<Route path="/payroll" element={<ProtectedRoute element={<Payroll searchTerm={searchTerm} />} />} />
<Route path="/payroll/list" element={<ProtectedRoute element={<Payroll searchTerm={searchTerm} />} />} />
<Route path="/payroll/paymentstatus" element={<ProtectedRoute element={<PayrollByPaymentStatus searchTerm={searchTerm} />} />} />
<Route path="/attendance" element={<ProtectedRoute element={<Attendance searchTerm={searchTerm} />} />} />
<Route path="/attendance/list" element={<ProtectedRoute element={<Attendance searchTerm={searchTerm} />} />} />
<Route path="/employeeschedules" element={<ProtectedRoute element={<EmployeeSchedules searchTerm={searchTerm} />} />} />
<Route path="/employeeschedules/list" element={<ProtectedRoute element={<EmployeeSchedules searchTerm={searchTerm} />} />} />
<Route path="/timetracking" element={<ProtectedRoute element={<TimeTracking searchTerm={searchTerm} />} />} />
<Route path="/timetracking/list" element={<ProtectedRoute element={<TimeTracking searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
